<template>
  <div class="layout">
    <header>
      <div class="header-box">
        <p class="logo">
          智慧云平台
        </p>
      </div>
    </header>
    <main class="login">
      <img
        src="../assets/background_logo.png"
        class="background" />
      <div class="form">
        <VerifyModal
          @success="success"
          ref="verifyModal"
        ></VerifyModal>
        <div class="title">
          <span>忘记密码</span>
        </div>
        <AuthMultipleInput
          ref="identifier"
          v-model="identifier"
          type="text"
          label="手机号"
          placeholder="手机号码"
          :maxlength="11"
          :rule="[
            { required: true, message: '手机号码不能为空', trigger: 'blur' },
            { pattern: pattern.phone, message: '手机号码不正确', trigger: `blur` },
          ]"
        ></AuthMultipleInput>
        <AuthMultipleInput
          ref="smsCaptcha"
          style="margin-top: 12px"
          v-model="smsCaptcha"
          type="smsCaptcha"
          label="短信验证码"
          placeholder="短信验证码"
          @sms-query="smsQuery"
          :maxlength="4"
          :rule="[
            { required: true, message: '短信验证码不能为空', trigger: 'blur' },
            { pattern: pattern.isNumber(4), message: '短信验证码不正确', trigger: `blur` },
          ]"
        ></AuthMultipleInput>
        <AuthMultipleInput
          ref="newCredential"
          v-model="newCredential"
          type="password"
          label="设置登录密码"
          placeholder="登录密码"
          :maxlength="20"
          :rule="[
            { required: true, message: '新登录密码不能为空', trigger: 'blur' },
            { validator: this.validateNewCredential, trigger: 'blur' },
          ]"
        ></AuthMultipleInput>
        <div style="color: #000">
          密码强度：长度9-20位，数字、大写、小写满足3种(且只支持该3种类型)
        </div>
        <div style="margin-top: 24px">
          <Button
            @click="submit"
            :loading="loading">
            保存
          </Button>
          <div class="form-bottom">
            已有账号?
            <router-link
              class="forgot-link"
              :to="{ name: `login` }">
              前往登录
            </router-link>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import AuthMultipleInput from '@/components/auth-multiple-input.vue';
import pattern from '@/util/pattern';
import {captchaSms, forgotPwd} from '@/service';
import {encrypt} from '@/util';
import {validationFormat} from '../util/password';
import VerifyModal from './components/verify-modal';

export default {
  name: 'FindPwd',
  components: {AuthMultipleInput, VerifyModal},
  data() {
    return {
      pattern,
      loading: false,
      identifier: '',
      // imageCaptcha: '',
      smsCaptcha: '',
      newCredential: '',
      callBack: null,
    };
  },

  methods: {
    validateNewCredential(rule, val, cb) {
      validationFormat(val) ?
        cb() :
        cb(new Error('密码强度：长度9-20位，数字、大写、小写满足3种(且只支持该3种类型)'));
    },
    smsQuery(next) {
      this.$refs['identifier'].isValid().then((v1) => {
        if (v1) {
          this.$refs.verifyModal.open();
          this.callBack = next;
        }
      });
    },
    success(captchaVerification) {
      this.$refs['identifier'].isValid().then((v1) => {
        if (v1) {
          captchaSms({
            deviceId: this.$store.getters['system/deviceId'],
            mobile: this.identifier,
            captchaVerification,
            senderId: '3',
          }).then(() => {
            this.callBack(60);
          });
        }
      });
    },
    submit() {
      Promise.all([
        this.$refs['identifier'].isValid(),
        this.$refs['smsCaptcha'].isValid(),
        this.$refs['newCredential'].isValid(),
      ]).then(([v1, v2, v3]) => {
        if (v1 && v2 && v3) {
          this.loading = true;
          forgotPwd({
            deviceId: this.$store.getters['system/deviceId'],
            identifier: this.identifier,
            smsCaptcha: this.smsCaptcha,
            newCredential: encrypt(this.newCredential),
          })
              .then((res) => {
                this.$Message.success('操作成功');
                this.$router.push(`/`);
              })
              .finally(() => {
                this.loading = false;
              });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.layout {
  width: 100%;
  height: 100vh;
  min-width: 1400px;
  background: #ffffff;
  overflow: hidden;
  header {
    display: flex;
    align-items: center;
    height: 64px;
    width: 100%;
    margin-left: 28px;
    .header-box {
      display: flex;
      flex-direction: column;
      width: 136px;
      text-align-last: justify;
      text-align: justify;
      text-justify: distribute-all-lines;
      .logo {
        font-size: 26px;
        color: #3f3f3f;
      }
      .path {
        font-size: 10px;
        color: #979797;
        font-weight: 600;
      }
    }
  }
  .login {
    position: relative;
    display: flex;
    align-items: center;
    height: calc(100vh - 136px);
    min-height: 600px;
    width: 100%;
    background: url("../assets/login_background.jpg") no-repeat;
    background-size: 100% 100%;
    .background {
      position: absolute;
      right: 56%;
      /*z-index: 1;*/
      width: 464px;
      height: 436px;
      margin-bottom: 80px;
    }
    .form {
      position: absolute;
      left: 56%;
      box-sizing: border-box;
      width: 360px;
      height: 455px;
      padding: 30px 48px 0;
      margin-bottom: 80px;
      border-radius: 6px;
      box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.17);
      background: #ffffff;
      .title {
        color: #1890ff;
        font-size: 20px;
        margin-bottom: 28px;
        span {
          position: relative;
          &:before {
            position: absolute;
            bottom: -6px;
            content: "";
            width: 100%;
            height: 3px;
            background: #1890ff;
            border-radius: 2px;
          }
        }
      }
      button {
        height: 38px;
        background: linear-gradient(270deg, rgba(24, 144, 255, 1) 0%, rgba(24, 144, 255, 1) 100%);
        border-radius: 4px;
        font-size: 14px;
        color: #fff;
        border: 0;
        outline: 0;
        width: 100%;
        margin-top: 4px;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }
      }
      .form-bottom {
        margin-top: 12px;
        text-align: right;
        .forgot-link {
          color: #1890ff;
          text-decoration: none;
        }
      }
    }
  }
  footer {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 72px;
    width: 100%;
    font-size: 11px;
    font-weight: 600;
    color: #979797;
  }
}
</style>
